import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'

import {
  SelectionOption,
  CalMaxIcon,
  StyleText,
  StyleDescription,
  ColorContainer,
  PriceContainer,
} from 'src/templates/CalendarProductPage/styles'
import StoreContext from 'src/context/StoreContext'
import { useStyleConfig } from '../../templates/SnapFramePage/styleConfig'
import {
  useCalStyleConfig,
  CAL_2_STYLE_OOS,
  FRAME_2_STYLE_OOS,
} from '../../templates/CalendarProductPage/styleConfig'

import ColorSelectionItem from '../ColorSelectionItem'
import { SEASONAL_PRODUCT_STATES } from '../../templates/FrameProductPage/seasonalConstants'
import { IN_SEASONAL_STATE, VIP_CODE } from '../../utils/constants'

const StyleOption = ({
  style,
  color,
  isSelected,
  handleSelection,
  smallRadio,
  plp,
  isCalendar,
}) => {
  const {
    store: {
      banner: { promoCode },
    },
  } = useContext(StoreContext)
  const calStyleConfig = useCalStyleConfig()
  const defaultStyleConfig = useStyleConfig()

  const styleConfig = isCalendar ? calStyleConfig : defaultStyleConfig
  const {
    description,
    basePrice,
    snapBasePrice,
    prices,
    defaultPrices,
    snapPrices,
    snapDefaultPrices,
  } = styleConfig[style]
  const selectedPriceSource = plp ? prices : snapPrices
  const selectedDefaultPrices = plp ? defaultPrices : snapDefaultPrices

  const inSeasonalState = IN_SEASONAL_STATE || promoCode === VIP_CODE
  const seasonalFrame10F2Prices = isCalendar
    ? SEASONAL_PRODUCT_STATES.prices.calendar15F2
    : SEASONAL_PRODUCT_STATES.prices.frame10F2

  const selectedPrices = isSelected ? selectedPriceSource[color] : selectedDefaultPrices
  const seasonalPrices = seasonalFrame10F2Prices[style]?.prices

  const finalSelectedPrices = inSeasonalState && seasonalPrices ? seasonalPrices : selectedPrices

  const { originalPrice, discountedPrice } = finalSelectedPrices

  const displayedPrice = originalPrice !== 'NONE' ? originalPrice : plp ? basePrice : snapBasePrice
  let displayedDiscountedPrice =
    discountedPrice !== 'NONE' ? discountedPrice : plp ? basePrice : snapBasePrice
  if (discountedPrice === 'NONE') {
    displayedDiscountedPrice = null
  }
  const images = plp ? styleConfig[style]?.image : styleConfig[style]?.snapImage
  const image = isSelected && images[color] ? images[color] : images[Object.keys(images)[0]]
  return (
    <SelectionOption
      selected={isSelected}
      key={color}
      onClick={() => handleSelection(style, color)}
    >
      <CalMaxIcon>
        <GatsbyImage
          image={image.childImageSharp.gatsbyImageData}
          alt={`${style} ${color} Frame 2`}
        />
      </CalMaxIcon>
      <ColorContainer>
        <StyleText>{style}</StyleText>
        {Object.keys(images).map((colorKey, i) => (
          <ColorSelectionItem
            isCalendar={isCalendar}
            key={`${i}-${colorKey}-${smallRadio}`}
            variant={colorKey}
            isOutOfStock={
              isCalendar
                ? CAL_2_STYLE_OOS?.[style]?.[colorKey]
                : FRAME_2_STYLE_OOS?.[style]?.[colorKey]
            }
            isSelected={color === colorKey}
            smallRadio={smallRadio}
            onSelectColor={() => handleSelection(style, colorKey)}
          />
        ))}
      </ColorContainer>
      <PriceContainer>
        <StyleText blue isDiscounted={displayedDiscountedPrice}>
          ${displayedPrice}
        </StyleText>
        {displayedDiscountedPrice && (
          <StyleText blue red>
            ${displayedDiscountedPrice}
          </StyleText>
        )}
      </PriceContainer>
      <StyleDescription>{description}</StyleDescription>
    </SelectionOption>
  )
}

StyleOption.propTypes = {
  style: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleSelection: PropTypes.func.isRequired,
  smallRadio: PropTypes.bool,
  plp: PropTypes.bool,
  isCalendar: PropTypes.bool,
}

export default StyleOption
